import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDiscord$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDiscord extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ed7f3ea60ff4fabcd16e12d6d21548bb1a8e1bd6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2ac7e35938b6a42160fe510e1932aab70bc35f80', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3dd4732009382511d49dbb344c1d778809b41335', d: "M17.248 5.143A15 15 0 0 0 13.534 4q-.263.47-.476.967a13.8 13.8 0 0 0-4.12 0Q8.724 4.472 8.461 4a15 15 0 0 0-3.717 1.145c-2.35 3.477-2.987 6.868-2.669 10.21a15 15 0 0 0 4.555 2.287q.554-.745.975-1.573a9.7 9.7 0 0 1-1.536-.733q.195-.142.377-.283a10.7 10.7 0 0 0 9.106 0q.185.152.377.283-.737.435-1.54.735.421.827.976 1.571a14.9 14.9 0 0 0 4.558-2.285c.373-3.876-.639-7.236-2.676-10.214M8.01 13.3c-.888 0-1.621-.805-1.621-1.796 0-.992.708-1.804 1.618-1.804s1.638.813 1.623 1.804c-.016.99-.715 1.796-1.62 1.796m5.98 0c-.889 0-1.62-.805-1.62-1.796 0-.992.708-1.804 1.62-1.804s1.634.813 1.618 1.804c-.015.99-.713 1.796-1.618 1.796", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-discord", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-discord"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-discord":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDiscord$1);
            }
            break;
    } });
}

const CosmosIconDiscord = CosmosIconDiscord$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDiscord, defineCustomElement };
